module.exports = __webpack_public_path__ + "static/media/two-occupants-dark.9497cfcc.svg";